
<div
    v-if="attachment"
    class       = "inbox-attachment"
    @click.stop = "onDetail"
    :style      = "isSelected ? 'background: #e8e8e8' : ''"
>
    <div class="v-flex">
        <div class="v-flex">
            <v-icon color="red" style="margin-top: -1px">
                {{ icon }}
            </v-icon>
            <v-icon color="primary" class="pl-1" style="margin-top: -1px" v-if="attachment.confirmed">
                mdi-check-circle
            </v-icon>
            <v-icon color="red" class="pl-1" style="margin-top: -1px" v-if="attachment.ignore">
                mdi-delete-outline
            </v-icon>
            <a>
                <v-icon color="red" class="pl-1" style="margin-top: -1px" v-if="attachment.duplicate">
                    mdi-alert-circle
                </v-icon>
            </a>
            <span class="pl-1">{{ typename }}</span>
        </div>
        <v-spacer />
        <div class="status">
            {{ attachment.status.name }}
        </div>
        
        <div class="quality" :class="attachment.quality.color">

        </div>
        <v-tooltip v-if="attachment.adpStatus" bottom>
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on   = "on"
                    small
                    :color = "adpStatusColor"
                    style  = "margin-top: -1px"
                    class  = "pl-1"
                >
                    {{ adpStatusIcon }}
                </v-icon>
            </template>
            <span>{{ adpStatusTooltip }}</span>
        </v-tooltip>
    </div>

    <div v-if="attachment && unit" class="unit">
        <span class="pr-1">{{ unit.fabricNo }}</span>
        <span class="pr-1">{{ unit.street }},</span>
        <span class="pr-1">{{ unit.zip }}</span>
        <span class="pr-1">{{ unit.city }}</span>
        <span v-if="unitCount > 1">(+ {{ unitCount - 1 }} weitere Anlagen)</span>
    </div>
    <div v-if="attachment && !unit" class="unit">
        <span class="pr-1"></span>
    </div>
    <div v-if="!attachment">

    </div>
</div>
